import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function ThankYouPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ backgroundColor: '#000000' }}>
      <div className="max-w-2xl mx-auto text-center">
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className="mb-8 flex justify-center">
            <div
              className="w-20 h-20 flex items-center justify-center"
              style={{ border: '2px solid #1E40AF' }}
            >
              <CheckCircle size={48} style={{ color: '#1E40AF' }} />
            </div>
          </div>

          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-5xl font-bold mb-6"
            style={{ fontFamily: 'Cormorant Garamond', color: '#FFFFFF', letterSpacing: '-0.5px' }}
          >
            Don't Thank Me
          </motion.h1>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="space-y-6 mb-10"
          >
            <p className="text-xl leading-relaxed" style={{ color: '#D1D5DB', fontFamily: 'DM Sans' }}>
              Thank <span style={{ color: '#1E40AF', fontWeight: 600 }}>yourself</span>.
            </p>
            <p className="text-lg leading-relaxed" style={{ color: '#9CA3AF', fontFamily: 'DM Sans' }}>
              You may have just broken the loop — the cycle you've been in financially — by taking this first step.
            </p>
            <p className="text-base leading-relaxed" style={{ color: '#6B7280', fontFamily: 'DM Sans' }}>
              Most people never make it this far. You did.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            className="pt-8 border-t"
            style={{ borderColor: 'rgba(255,255,255,0.1)' }}
          >
            <h3 className="text-xl font-bold mb-4" style={{ fontFamily: 'Cormorant Garamond', color: '#FFFFFF' }}>
              What Happens Next
            </h3>

            <div className="space-y-3 mb-8">
              <div className="flex items-start gap-3 text-left">
                <div className="w-1.5 h-1.5 mt-2 flex-shrink-0" style={{ backgroundColor: '#1E40AF' }} />
                <p className="text-sm" style={{ color: '#D1D5DB', fontFamily: 'DM Sans' }}>
                  You'll receive a calendar confirmation at the email you provided
                </p>
              </div>
              <div className="flex items-start gap-3 text-left">
                <div className="w-1.5 h-1.5 mt-2 flex-shrink-0" style={{ backgroundColor: '#1E40AF' }} />
                <p className="text-sm" style={{ color: '#D1D5DB', fontFamily: 'DM Sans' }}>
                  Adam will reach out 24 hours before your scheduled call
                </p>
              </div>
              <div className="flex items-start gap-3 text-left">
                <div className="w-1.5 h-1.5 mt-2 flex-shrink-0" style={{ backgroundColor: '#1E40AF' }} />
                <p className="text-sm" style={{ color: '#D1D5DB', fontFamily: 'DM Sans' }}>
                  Come prepared with questions about your current trading approach
                </p>
              </div>
            </div>

            <a href="/">
              <Button
                className="h-12 px-8 text-sm font-semibold inline-flex items-center gap-2"
                style={{
                  backgroundColor: 'transparent',
                  color: '#FFFFFF',
                  border: '1px solid rgba(255,255,255,0.2)',
                  fontFamily: 'DM Sans',
                  letterSpacing: '0.5px',
                }}
              >
                RETURN HOME
                <ArrowRight size={16} />
              </Button>
            </a>
          </motion.div>

          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.8 }}
            className="mt-12 text-xs"
            style={{ color: '#6B7280', fontFamily: 'DM Sans' }}
          >
            See you on the call.
          </motion.p>
        </motion.div>
      </div>
    </div>
  );
}
